import {
  Button,
  DestructiveIcon,
  Flex,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';
import { AxiosError } from 'axios';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';

export default function LoginFailureBlockModal({
  title,
  error,
}: {
  title: string;
  error: AxiosError;
}) {
  const dispatch = useDispatch();

  return (
    <Flex justifyContent="center" width="100%">
      <Flex p={4} width="xs">
        <Flex
          alignItems="center"
          backgroundColor={'#fff'}
          borderRadius={'3px'}
          boxShadow="0px 60px 40px -30px rgba(0, 0, 0, 0.34902)"
          flexDirection="column"
          pb={8}
          pt={7}
          px={[6, 8]}
          width="100%"
        >
          <ModalTitle fontSize="20px" icon={<DestructiveIcon color="iconPrimaryBase" />}>
            {title}
          </ModalTitle>
          <ModalContent alignItems="center" gap={2}>
            <Text fontWeight="medium">5회 연속 로그인에 실패했습니다.</Text>
            <Text textAlign="center">
              안전한 이용을 위해 10분간 로그인이 제한됩니다.
              <br />
              잠시 후인{' '}
              <Text color="textEmphasisBase">
                {moment(error.response?.data.data.blockUntil)
                  .format('LT')
                  .split(':')
                  .join('시 ')}
                분{' '}
              </Text>
              이후 재시도해 주세요.
            </Text>
          </ModalContent>
          <ModalFooter>
            <Button
              variant="subtle"
              weight="light"
              onClick={() => {
                dispatch(modalClose());
              }}
            >
              확인
            </Button>
          </ModalFooter>
        </Flex>
      </Flex>
    </Flex>
  );
}
